
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policy/payment-guarantee",
      function () {
        return require("private-next-pages/policy/payment-guarantee.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policy/payment-guarantee"])
      });
    }
  